import styles from "./styles.module.scss";

export interface ISuggestie {
  label: string;
  waarde: string;
}

interface Props {
  id: string;
  tekst?: string;
  suggesties: ISuggestie[];
  onApply: (waarde: string) => void;
  disabled?: boolean;
}

export function SuggestieMolecule(props: Readonly<Props>) {
  if (props.suggesties.length === 0) return null;

  return (
    <div className={styles.suggestie}>
      <span className={styles.suggestie__tekst}>{props.tekst ?? "Suggestie"}:</span>
      {props.suggesties.map((suggestie) => (
        <button
          key={suggestie.label + suggestie.waarde}
          id={`${props.id}_${suggestie.label}`}
          type="button"
          className={styles.suggestie__chip}
          disabled={props.disabled}
          onClick={() => props.onApply(suggestie.waarde)}
        >
          {`${suggestie.label}: ${suggestie.waarde}`}
        </button>
      ))}
    </div>
  );
}
